/* OddDrop gallery observation v1. Uses existing consent + GA4 emitter only. */
(function () {
  'use strict';
  if (window.OddGalleryAnalytics) return;
  var VERSION = '20261021_v1';
  var METHODS = ['arrow_next', 'arrow_previous', 'swipe', 'thumbnail', 'dot', 'lightbox', 'variant', 'initial', 'unknown'];
  var MANUAL = ['arrow_next', 'arrow_previous', 'swipe', 'thumbnail', 'dot', 'lightbox'];
  var TARGETS = [2, 3, 5];
  var controllers = [];

  function allowed() {
    return !!(window.OddConsent && window.OddConsent.allowed() && window.OddTracking);
  }

  function makeController(root) {
    var track = root.querySelector('[data-track]');
    var box = root.querySelector('.pdp-main-wrap');
    if (!track || !box) return null;
    var slides = Array.prototype.slice.call(track.children);
    if (!slides.length) return null;
    var overlay = root.querySelector('[data-zoom-overlay]') || document.querySelector('[data-zoom-overlay]');
    var zoomImage = overlay && overlay.querySelector('[data-zoom-img]');
    var productEl = document.querySelector('[data-od-current-product]');
    var product = {};
    try { product = JSON.parse(productEl.textContent); } catch (_) {}
    var productId = /^\d+$/.test(String(product.id || '')) ? String(product.id) : '';
    var imageNumbers = [], imageTotal = 0;
    slides.forEach(function (slide, index) {
      imageNumbers[index] = !slide.classList.contains('pdp-slide--video') && slide.querySelector('img.pdp-main-img') ? ++imageTotal : 0;
    });
    var current = Math.max(0, Math.min(slides.length - 1, Number(root.getAttribute('data-gallery-index') || 0)));
    var source = 'initial', visited = false, interacted = false, interactedSent = false;
    var seen = {}, activeSeen = {}, pending = null, pendingKey = '', scrollTimer = null;
    var lastConsent = allowed();

    function emit(name, data) {
      if (!allowed()) return false;
      try {
        return window.OddTracking.emit(name, Object.assign({
          gallery_tracking_version: VERSION,
          product_id: productId,
          gallery_image_count: imageTotal,
          gallery_media_count: slides.length
        }, data || {})) === true;
      } catch (_) { return false; }
    }

    function mediaParams(index) {
      return { media_index: index, media_number: index + 1,
        image_number: imageNumbers[index] || 0,
        media_type: imageNumbers[index] ? 'image' : (slides[index].classList.contains('pdp-slide--video') ? 'video' : 'other'),
        interaction_method: source };
    }

    function cancel() {
      if (pending !== null) clearTimeout(pending);
      pending = null; pendingKey = '';
    }

    function overlayOpen() {
      return !!(overlay && !overlay.hidden && overlay.getClientRects().length);
    }

    function observation() {
      if (!allowed() || document.hidden) return null;
      var isZoom = overlayOpen();
      var target = isZoom ? zoomImage : box;
      if (!target || !target.getClientRects().length) return null;
      var style = window.getComputedStyle(target);
      if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return null;
      var r = target.getBoundingClientRect();
      if (r.width <= 0 || r.height <= 0) return null;
      var w = Math.max(0, Math.min(r.right, innerWidth) - Math.max(r.left, 0));
      var h = Math.max(0, Math.min(r.bottom, innerHeight) - Math.max(r.top, 0));
      if ((w * h) / (r.width * r.height) < 0.5) return null;
      var image = isZoom ? zoomImage : slides[current].querySelector('img.pdp-main-img');
      return { index: current, image: image, surface: isZoom ? 'lightbox' : 'inline',
        key: String(current) + ':' + (isZoom ? 'lightbox' : 'inline') + ':' + (image ? image.currentSrc || image.src || '' : '') };
    }

    function syncInteracted() {
      if (!visited || !interacted) return;
      if (!interactedSent) interactedSent = emit('product_gallery_interacted_visit');
      if (!interactedSent) return;
      Object.keys(seen).forEach(function (key) {
        if (!activeSeen[key] && emit('product_gallery_active_image', mediaParams(Number(key)))) activeSeen[key] = true;
      });
    }

    function qualify(snapshot) {
      var now = observation();
      if (!now || now.key !== snapshot.key) return;
      if (!visited) {
        visited = emit('product_gallery_visit', { gallery_surface: now.surface });
        if (!visited) return;
        TARGETS.forEach(function (n) { if (imageTotal >= n) emit('product_gallery_eligible_' + n); });
      }
      var index = now.index;
      var image = now.image;
      // Loaded pixels, not preload requests or video posters, constitute an image view.
      if (imageNumbers[index] && image && image.complete && image.naturalWidth > 0 && !seen[index]) {
        var params = Object.assign(mediaParams(index), { gallery_surface: now.surface });
        if (emit('product_gallery_image_view', params)) {
          seen[index] = true;
          if (TARGETS.indexOf(imageNumbers[index]) !== -1) emit('product_gallery_image_' + imageNumbers[index] + '_view', params);
        }
      }
      syncInteracted();
    }

    function schedule() {
      var snapshot = observation();
      if (!snapshot) { cancel(); return; }
      if (pending !== null && pendingKey === snapshot.key) return;
      cancel();
      pendingKey = snapshot.key;
      pending = setTimeout(function () {
        pending = null; pendingKey = '';
        qualify(snapshot);
      }, 500);
    }

    function changed(event) {
      if (event.target !== root) return;
      var detail = event.detail || {};
      var index = Number(detail.media_index);
      if (!Number.isInteger(index) || index < 0 || index >= slides.length || index === current) return;
      cancel();
      current = index;
      source = METHODS.indexOf(detail.interaction_method) !== -1 ? detail.interaction_method : 'unknown';
      if (allowed() && !document.hidden) {
        emit('product_gallery_change', mediaParams(index));
        if (MANUAL.indexOf(source) !== -1) {
          interacted = true;
          emit('product_gallery_manual_change', mediaParams(index));
          if (source === 'swipe') emit('product_gallery_swipe', mediaParams(index));
          syncInteracted();
        }
      }
      schedule();
    }

    function reset() {
      cancel(); visited = false; interacted = false; interactedSent = false;
      seen = {}; activeSeen = {}; source = 'initial';
    }

    root.addEventListener('od:gallery-change', changed);
    root.querySelectorAll('[data-track] img.pdp-main-img').forEach(function (image) {
      image.addEventListener('load', schedule);
      image.addEventListener('error', function () { cancel(); schedule(); });
    });
    if (zoomImage) zoomImage.addEventListener('load', schedule);
    if (typeof IntersectionObserver !== 'undefined') {
      var observer = new IntersectionObserver(schedule, { threshold: [0, 0.5, 1] });
      observer.observe(box);
      if (zoomImage) observer.observe(zoomImage);
    }
    if (overlay && typeof MutationObserver !== 'undefined') {
      new MutationObserver(function () { cancel(); schedule(); }).observe(overlay, { attributes: true, attributeFilter: ['hidden', 'style'] });
    }
    document.addEventListener('visibilitychange', function () { cancel(); schedule(); });
    document.addEventListener('od:consent', function () {
      var next = allowed();
      if (next !== lastConsent) { reset(); lastConsent = next; }
      schedule();
    });
    window.addEventListener('scroll', function () {
      // Check immediately so a view interrupted before 500ms never qualifies.
      if (!observation()) cancel();
      if (scrollTimer !== null) clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () { scrollTimer = null; schedule(); }, 80);
    }, { passive: true });
    window.addEventListener('resize', function () { cancel(); schedule(); }, { passive: true });
    window.addEventListener('pagehide', cancel);
    window.addEventListener('pageshow', function (event) { if (event.persisted) schedule(); });
    schedule();
    return { version: VERSION };
  }

  function boot() {
    document.querySelectorAll('.pdp[data-pdp-root]').forEach(function (root) {
      if (root.hasAttribute('data-gallery-analytics-ready')) return;
      var controller = makeController(root);
      if (controller) { root.setAttribute('data-gallery-analytics-ready', VERSION); controllers.push(controller); }
    });
  }

  window.OddGalleryAnalytics = { version: VERSION };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
